import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faClock } from "@fortawesome/free-regular-svg-icons"

export const ClockRegular = (props) => {
  return <FontAwesomeIcon faIcon={faClock} {...props} />
}
